import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ContentWithCardLoading } from "../../../components/loading";
import AdvanceDataTable from "../../../components/normal-table/advance-table";
import ContentWrapper from "../../Wrapper";
import WalletHistorySubheader from "../components/wallet-history-subheader";
import * as GlobalTransactionsActions from "../store/actions/global_transactions_actions";

export default function WalletImpTransactions(props) {
    const tabName = "Global Imp Transactions";
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10)

    const dispatch = useDispatch();

    const globalImpTransactionsStore = useSelector(store => store.walletHistory.global.impTransactions);

    useEffect(() => {
        dispatch(GlobalTransactionsActions.getGlobalImpTransactionsRequest({ page: page, limit: limit }))
    }, [dispatch, page, limit])

    return <ContentWrapper subHeader={<WalletHistorySubheader tabName={tabName} />}>
        {globalImpTransactionsStore.loading ? (
            <ContentWithCardLoading />
        ) : globalImpTransactionsStore.data.length === 0 ? (
            "No data"
        ) : (
            <div className={`card card-custom`}>
                <div className="card-body py-3 px-3" style={{ padding: 15 }}>
                    <AdvanceDataTable
                        columns={[
                            { title: "AccountId", apiKeyName: "accountId", fieldInputType: "INPUT" },
                            { title: "Source", apiKeyName: "source", fieldInputType: "INPUT" },
                            { title: "Channel", apiKeyName: "channel", fieldInputType: "INPUT" },
                            { title: "Mode", apiKeyName: "mode", fieldInputType: "INPUT" },
                            { title: "Type", apiKeyName: "type", fieldInputType: "INPUT" },
                            { title: "Amount", apiKeyName: "amount", fieldInputType: "INPUT" },
                            { title: "Old Balance", apiKeyName: "oldBalance", fieldInputType: "INPUT" },
                            { title: "New Balance", apiKeyName: "newBalance", fieldInputType: "INPUT" },
                            { title: "Remark", apiKeyName: "remark", fieldInputType: "INPUT" },
                            { title: "Time", apiKeyName: "createdAt", fieldInputType: "DATE_TIME" },
                        ]}
                        data={globalImpTransactionsStore.data}
                        limit={limit}
                        pageNo={page}
                        setLimit={setLimit}
                        setPageNo={setPage}
                        count={globalImpTransactionsStore.count}
                    />
                </div>
            </div>
        )}
    </ContentWrapper>
}